var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { cloneElement, forwardRef, useState } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import ArcoCollapse from './core';
import Header from './header';
import './style/collapse.less';
var ItemRender = function (props, ref) {
    var _a;
    var _b;
    var _c = __read(useState(false), 2), focus = _c[0], setFocus = _c[1];
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-collapse-item");
    var _d = props.header, _e = _d === void 0 ? {} : _d, avatar = _e.avatar, title = _e.title, tag = _e.tag, subTitle = _e.subTitle, render = _e.render, _f = props.wrapperProps, wrapperProps = _f === void 0 ? {} : _f, rest = __rest(props, ["header", "wrapperProps"]);
    var disabled = rest.disabled;
    var extra = rest.extra;
    if (disabled) {
        if (React.isValidElement(extra)) {
            extra = ((_b = extra === null || extra === void 0 ? void 0 : extra.props) === null || _b === void 0 ? void 0 : _b.disabled)
                ? extra
                : cloneElement(extra, { style: { opacity: 0.25 } });
        }
        else {
            extra = React.createElement("span", { className: "".concat(prefixCls, "-header-disabled") }, extra);
        }
    }
    // extra 需要阻止focus事件冒泡，否则触发Collapse.Item的focus状态
    extra = (React.createElement("span", { onFocus: function (e) {
            e.stopPropagation();
        } }, extra));
    var getHeader = function () {
        return (React.createElement(Header, { avatar: avatar, title: title, subTitle: subTitle, tag: tag, disabled: disabled }));
    };
    return (
    // ArcoCollapse没有继承HTMLAttributes,给外部封装一个div
    React.createElement("div", __assign({ "data-tid": "m4b_collapse_item" }, wrapperProps, { onFocus: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setFocus(true);
            (_a = wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.onFocus) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([wrapperProps], __read(args), false));
        }, onBlur: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setFocus(false);
            (_a = wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.onBlur) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([wrapperProps], __read(args), false));
        }, className: cx(prefixCls, (_a = {}, _a["".concat(prefixCls, "-disabled")] = !!disabled, _a["".concat(prefixCls, "-focus")] = focus, _a), wrapperProps.className) }),
        React.createElement(ArcoCollapse.Item, __assign({}, rest, { extra: extra, header: render ? render() : getHeader(), ref: ref }))));
};
var Item = forwardRef(ItemRender);
Item.displayName = 'Collapse.Item';
export default Item;
